// StyleSheet compatibility for React Native styles
const StyleSheet = {
  create: (styles) => styles,
  
  // Common style utilities
  absoluteFill: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  
  absoluteFillObject: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  
  hairlineWidth: 1,
  
  flatten: (styles) => {
    if (!styles) return {};
    if (Array.isArray(styles)) {
      return styles.reduce((acc, style) => ({ ...acc, ...style }), {});
    }
    return styles;
  }
};

export default StyleSheet;